import React,{ useState } from 'react';
import { useCookieConsent } from '../hooks/useCookieConsent';

const CookieConsent: React.FC = () => {
  const { hasConsent, saveConsent } = useCookieConsent();
  const [showModal, setShowModal] = useState(false);
  const [categories, setCategories] = useState({
    essential: true,
    analytics: false,
    marketing: false,
  });

  const handleAcceptAll = () => {
    const allCategories = { essential: true, analytics: true, marketing: true };
    saveConsent(true, allCategories);
  };

  const handleReject = () => {
    const rejectCategories = { essential: true, analytics: false, marketing: false };
    saveConsent(false, rejectCategories);
  };

  const handleConfigure = () => {
    setShowModal(true);
  };

  const handleSavePreferences = () => {
    saveConsent(true, categories);
  };

  const handleCategoryChange = (category: keyof typeof categories) => {
    if (category === 'essential') return;
    setCategories(prev => ({ ...prev, [category]: !prev[category] }));
  };

  if (hasConsent) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg z-50">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="flex-1 mb-4 md:mb-0 md:mr-4">
          <p className="text-sm text-gray-700">
            Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. Las cookies esenciales son necesarias para el funcionamiento del sitio, mientras que las de análisis y marketing nos ayudan a entender cómo usas el sitio y a mostrarte contenido relevante.
            <a href="/cookies" className="text-blue-600 hover:underline ml-1">
              Más información
            </a>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <button onClick={handleReject} className="bg-gray-200 text-gray-800 px-3 py-2 rounded text-xs hover:bg-gray-300">
            Rechazar no esenciales
          </button>
          <button onClick={handleConfigure} className="bg-gray-200 text-gray-800 px-3 py-2 rounded text-xs hover:bg-gray-300">
            Configurar
          </button>
          <button onClick={handleAcceptAll} className="bg-blue-600 text-white px-3 py-2 rounded text-xs hover:bg-blue-700">
            Aceptar todas
          </button>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h2 className="text-lg font-semibold mb-4">Configurar cookies</h2>
            <div className="space-y-3">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={categories.essential}
                  disabled
                  className="mr-2"
                />
                <label className="text-sm">Cookies esenciales (siempre activas)</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={categories.analytics}
                  onChange={() => handleCategoryChange('analytics')}
                  className="mr-2"
                />
                <label className="text-sm">Cookies de análisis</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={categories.marketing}
                  onChange={() => handleCategoryChange('marketing')}
                  className="mr-2"
                />
                <label className="text-sm">Cookies de marketing</label>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button onClick={() => setShowModal(false)} className="bg-gray-200 text-gray-800 px-3 py-2 rounded text-xs hover:bg-gray-300">
                Cancelar
              </button>
              <button onClick={handleSavePreferences} className="bg-blue-600 text-white px-3 py-2 rounded text-xs hover:bg-blue-700">
                Guardar preferencias
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieConsent;